import { createReducer, on } from "@ngrx/store";
import { setAccessToken } from "../actions/token.actions";

export interface AuthState {
    accessToken: string | null;
    refreshToken: string | null;
}

export const initialState: AuthState = { accessToken: null , refreshToken: null};

export const authReducer  = createReducer(
    initialState,
    on(setAccessToken,(state, {accessToken, refreshToken}) => ({...state, accessToken, refreshToken}))
)